var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('l-geo-json',{ref:"geojsonLayer",attrs:{"id":"geojsonLayer","options":{ style: _vm.reactiveStyle, pointToLayer: _vm.pointToLayer, onEachFeature: _vm.onEachFeature },"geojson":_vm.geometries}})
}
var staticRenderFns = []

export { render, staticRenderFns }